module.exports = __webpack_public_path__ + "static/media/S (166).cd5e9371.jpg";